module.exports = __webpack_public_path__ + "static/media/bikeIcon.1609027e.svg";